import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_myqj9vpqyk: FaireBrandEntity = {
  token: "b_myqj9vpqyk",
  type: "brand",
  name: "JAR Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/71afbacb398e9c5cfc6e806d2a7d7f77cf8f422fbacb5f78ddf0adb5cdff4c5d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4f91f5e580f5efb37c15840a322b56f0050ba1e1ffd937d742b036a21e171885.png",
  logoUrl:
    "https://cdn.faire.com/fastly/71afbacb398e9c5cfc6e806d2a7d7f77cf8f422fbacb5f78ddf0adb5cdff4c5d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4f91f5e580f5efb37c15840a322b56f0050ba1e1ffd937d742b036a21e171885.png",
  location: "Beebe, AR, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 9,
  isTopShop: true,
  isInsider: true,
  description:
    '🎯 JAR Co\n"Your one-stop partner for Branding, Custom Apparel, Printing, Packaging, and Promotionals. We bring your brand to life — from concept to delivery. 📦✨"\n\n📍Based in Beebe, Arkansas | 📲 DM us to grow your brand!\n\nOur sister company is Adelle Linen. Where you will women\'s trendy, graphic apparel! Here is the direct Faire link to us out!\nhttps://faire.com/direct/adellelinen',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:12.544Z",
    importedBy: "entity-db-cli",
  },
};
